import name from 'assets/images/kukyang/name.png';

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain() {
  return <img src={name} alt="국양건축사사무소" style={{ width: 200, height: 'auto', display: 'block' }} />;
}
